module.exports = __webpack_public_path__ + "assets/50f7461fca42e8c61a7724c6c93ad76d.svg";